import { onCLS, onFCP, onINP, onLCP } from "web-vitals/attribution";

import { performanceBeaconTracker } from "./web-vitals/metrics";
import { trackConnectionType } from "./tracking/connection";
import { initRumCollection } from "./rum/rum";
import { addApmLabels, addCspCookieApmLabel, addLcpApmLabels } from "./web-vitals/apm";


/*                            */
onLCP(performanceBeaconTracker);
onFCP(performanceBeaconTracker);
onCLS(performanceBeaconTracker);
onINP(performanceBeaconTracker);

/*                             */
onINP(addApmLabels, { reportAllChanges: true });
onCLS(addApmLabels, { reportAllChanges: true });
/*                                  */
onLCP(addLcpApmLabels, { reportAllChanges: true });

/*                                    */
initRumCollection();
addCspCookieApmLabel();

/*                                         */
trackConnectionType();
